// assets
import ApartmentOutlined from '@ant-design/icons/ApartmentOutlined';

// type
import { NavItemType } from '@/types/menu';

// ==============================|| MENU ITEMS - MODERATOR DE CARTIER ||============================== //
// Moderatorul de cartier are o singură destinație: pagina cartierului lui. Meniul standard
// (filtrat pe permisiuni) i-ar arăta, de pildă, chatul general — de aceea primește meniul acesta.

export const moderatorMenuItems = (homePath: string): NavItemType[] => [
	{
		id: 'group-moderator',
		title: 'menu.application',
		type: 'group',
		children: [
			{
				id: 'cartierul-meu',
				title: 'menu.myNeighborhood',
				type: 'item',
				url: homePath,
				icon: ApartmentOutlined
			}
		]
	}
];
